<div class="header">
  <app-nav></app-nav>
</div>
<div class="content">
  <router-outlet></router-outlet>
</div>
<div class="footer">

</div>
